export default __webpack_public_path__ + "static/media/gallery-wip-ammo-port-enclosure-box_03.e4dcc605.jpg";